import axios from 'axios'
import moment from 'moment'
import { request } from '../middleware/auth-intercepter'
import { API_TYPE } from '../utils/Utils'
import CustomLogger from '../utils/CustomLogger'

let APIURL = process.env.REACT_APP_SERVER_URL + '/api/v1'

export const getAllUser = async (data) => {
  try {
    const apiUrl = `/web/users/allUser?${data}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response.data
  } catch (error) {
    CustomLogger.error('Error in Get All User', error.message)
    return error.message
  }
}

export const getBlockAlerts = async (data) => {
  try {
    const apiUrl = `/web/users/block/alerts`
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in getBlockAlerts', error.message)
    return error.message
  }
}

export const updateBlockAlertStatus = async (alertId, status, reason = '') => {
  try {
    const apiUrl = `/web/users/block/alerts/update`
    let response = await request(apiUrl, API_TYPE.POST, { alertId, status, reason }, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in updateBlockAlertStatus', error.message)
    return error.message
  }
}

export const deleteUserAccount = async (userIDs) => {
  try {
    let formdata = new FormData()
    formdata = {
      userIds: userIDs,
    }

    const apiUrl = `/web/users/delete`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    return error.message
  }
}

export const suspendAccount = async (userId, isSuspended, reason = null) => {
  try {
    const apiUrl = `/web/users/suspend-account`
    let data = {
      userId: userId,
      isSuspended: isSuspended,
      reason: reason,
    }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    return error.message
  }
}

export const suspendDevice = async (userId, isDeviceSuspended, reason = null) => {
  try {
    const apiUrl = `/web/users/suspend-device`
    let data = {
      userId: userId,
      isDeviceSuspended: isDeviceSuspended,
      reason: reason,
    }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    return error.message
  }
}

export const activeInactiveUser = async (userIDs, status) => {
  try {
    let data = {
      userIds: userIDs,
      status: status,
    }

    const apiUrl = `/anonymous/users/updatestatus`

    let response = await request(apiUrl, API_TYPE.PUT, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}


export const getAllGender = async (genderName) => {
  try {
    const apiUrl = `/masters/genders`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const loginWithEmailAndPassword = async (email, password) => {
  const apiUrl = `/auth/admin/login`

  let data = {
    email: email,
    password: password,
  }

  let response = await request(apiUrl, API_TYPE.POST, data, false, false)

  if (response.success) {
    localStorage.setItem('accessToken', response.data.token)
    sessionStorage.setItem('accessToken', response.data.token)
    localStorage.setItem('loginUserId', response.data.adminUserId)
  }

  return response.data
}

export const getCountriesList = async () => {
  try {
    const apiUrl = `/masters/countries`

    let response = await request(apiUrl, API_TYPE.GET, {}, true)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserProfileDetailsUsingUserID = async (userID) => {
  try {
    const apiUrl = `/web/users/profile/${userID}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserActivityWithPagination = async (page, pageSize, type, userID, filter) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
      type: type,
    }
    if (filter.type === 'lastHour') {
      data['lastHour'] = filter.type
    }

    if (filter.type === 'lastDay') {
      data['lastDay'] = filter.type
    }

    if (filter.type === 'lastWeek') {
      data['lastWeek'] = filter.type
    }

    if (filter.type === 'custom') {
      data['startDate'] = filter.startDate
      data['endDate'] = filter.endDate
    }

    const apiUrl = `/web/users/activities/`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getDashboardActivityWithPagination = async (page, pageSize, type) => {
  try {
    let data = {
      type: type,
      page: page,
      pageSize: pageSize,
    }

    const apiUrl = `/web/users/activities/dashboard`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllInterest = async () => {
  try {
    const apiUrl = `/masters/interests`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const createInterest = async (name) => {
  try {
    let data = {
      name: name,
    }

    const apiUrl = `/masters/interests`
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const updateInterest = async (interestId, name) => {
  try {
    let data = {
      name: name,
    }

    const apiUrl = `/masters/interests/${interestId}`
    let response = await request(apiUrl, API_TYPE.PUT, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const removeInterest = async (interestId) => {
  try {
    const apiUrl = `/masters/interests/${interestId}`
    let response = await request(apiUrl, API_TYPE.DELETE, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}


export const addUserInterest = async (userID, interestId) => {
  try {
    let data = {
      interestId: interestId,
    }

    const apiUrl = `/users/${userID}/interest`
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const removeUserInterest = async (userID, interestId) => {
  try {
    let data = {
      interestId: interestId,
    }

    const apiUrl = `/users/${userID}/interest`
    let response = await request(apiUrl, API_TYPE.DELETE, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const addQuestions = async (question, order, inputType, genderId) => {
  try {
    let formdata = new FormData()
    formdata.append('question', question)
    formdata.append('order', order)
    formdata.append('inputType', inputType)

    if (genderId !== 0) {
      formdata.append('genderId', parseInt(genderId))
    }

    const apiUrl = `/masters/questions`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, true)

    // Using request middleware formats the response, so we return it directly. 
    // Depending on what the component expects, this might need tweaking.
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const updateQuestions = async (updatedData, file) => {
  try {
    let formdata = new FormData()
    formdata.append('question', updatedData.question)
    formdata.append('order', updatedData.order)
    formdata.append('inputType', updatedData.inputType)
    
    if (updatedData.genderId !== undefined) {
      formdata.append('genderId', updatedData.genderId)
    }
    
    if (file) {
      formdata.append('questionIcon', file)
    }

    const apiUrl = `/masters/questions/${updatedData.questionId}`

    let response = await request(apiUrl, API_TYPE.PUT, formdata, true, true)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const addAnswer = async (answer, questionId) => {
  try {
    let data = {
      answer: answer,
      questionId: questionId,
    }

    const apiUrl = `/masters/answers`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateAnswers = async (answers) => {
  //
  try {
    let data = {
      answers: answers,
    }

    const apiUrl = `/masters/answers`

    let response = await request(apiUrl, API_TYPE.PUT, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserQuestionAnswerForProfile = async () => {
  try {
    const apiUrl = `/masters/questions/answer`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getUserMedia = async (userID, page, pageSize) => {
  try {
    let accessToken = localStorage.getItem('accessToken')

    const apiUrl = `${APIURL}/users/${userID}/profile/media?page=${page}&pageSize=${pageSize}`

    let response = await axios.get(apiUrl, {
      headers: {
        'Content-Type': `application/json`,
        'x-access-token': accessToken,
      },
    })

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateMediaActionForUserMedia = async (userID, mediaID) => {
  try {
    let data = {
      isProfileImage: true,
      id: mediaID,
      userId: userID,
    }

    const apiUrl = `/web/users/media/update`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const removeMediaActionForUserMedia = async (userID, mediaID) => {
  try {
    const apiUrl = `/web/users/media/delete`

    let response = await request(apiUrl, API_TYPE.POST, { userId: userID, id: mediaID }, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createMediaActionForUserMedia = async (fileData, userID, userType) => {
  try {
    let formData = new FormData()

    formData.append('userId', userID)

    fileData.forEach((file, i) => {
      const fileName = `${userType}_${userID}_${i}.webp`
      formData.append('profileMedia', file, fileName)
    })

    const apiUrl = `/web/users/upload/profiles`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, true)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const createMediaActionForUserMediaForAnonymousUser = async (fileData, userID, userType) => {
  try {
    let formData = new FormData()

    fileData.forEach((file, i) => {
      const fileName = `${userType}_${userID}_${i}.webp`
      formData.append('anonymousProfileMedia', file, fileName)
      formData.append(`mediaTypes[${i}][mediaType]`, 'photo')
    })

    const apiUrl = `/users/${userID}/upload/profiles/web`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, true)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}


export const getUserCreditsHistoryWithPagination = async (
  userID,
  page,
  pageSize,
  creditType,
  filterValue,
  historyType
) => {
  try {
    let data = { userId: userID, page: page, pageSize: pageSize, type: creditType }
    if (filterValue.creditTitle) {
      data['creditHistoryTitle'] = filterValue.creditTitle
    }

    if (filterValue.startDate && filterValue.endDate) {
      data['startDate'] = filterValue.startDate
      data['endDate'] = filterValue.endDate
    }

    if (historyType) {
      data['historyType'] = historyType
    }

    const apiUrl = `/web/users/credits/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserPurchaseHistoryWithPagination = async (userID, page, pageSize) => {
  try {
    let formdata = new FormData()
    formdata = {
      userId: userID,
      page: page,
      pageSize: pageSize,
    }

    const apiUrl = `/web/purchase/history`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const UpdateUserDetailsByUID = async (UID, newUserData) => {
  try {
    let formdata = new FormData()
    formdata = {
      mobileNo: newUserData.mobileNo,
      countryCode: newUserData.countryCode,
      fullName: newUserData.fullName,
      userName: newUserData.userName,
      email: newUserData.email,
      genderId: parseInt(newUserData.gender),
      country: newUserData.country,
      lat: newUserData.lat,
      lng: newUserData.lng,
      age: newUserData.age,
      bio: newUserData.bio,
      questions: JSON.stringify(newUserData?.questions),
      interests: JSON.stringify(newUserData?.interests),
    }

    const apiUrl = `/web/users/update/${UID}`

    let response = await request(apiUrl, API_TYPE.PUT, formdata, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const UpdateVerifyStatusByUID = async (UID, flag) => {
  try {
    let formdata = new FormData()
    formdata = {
      isVerify: flag,
    }

    const apiUrl = `/web/users/update/${UID}`

    let response = await request(apiUrl, API_TYPE.PUT, formdata, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const UpdateSpotlightStatusByUID = async (UID, duration, type) => {
  try {
    let formData = new FormData()
    formData = {
      duration: duration,
      type: type,
      userId: UID,
    }

    const apiUrl = `/web/users/spotlight/update`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const AddOrUpdateCreditByUserId = async (userId, type, credit, reason) => {
  try {
    let formData = new FormData()
    formData = {
      type: type,
      credit: credit,
      userId: userId,
      reason: reason,
    }

    const apiUrl = `/web/users/send/credit`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const AddOrUpdateDiamondsByUserId = async (userId, type, diamond, reason) => {
  try {
    let formData = new FormData()
    formData = {
      type: type,
      diamond: diamond,
      userId: userId,
      reason: reason,
    }

    const apiUrl = `/web/users/send/diamond`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const AddOrUpdatePremiumByUID = async (
  UID,
  type,
  days,
  premiumPackageAmountId,
  paymentVia
) => {
  try {
    let formData = new FormData()
    formData = {
      userId: UID,
      type: type,
      days: days,
      premiumPackageAmountId: premiumPackageAmountId,
      paymentVia: paymentVia,
    }

    const apiUrl = `/web/users/send/premium`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

// /:userId/remove/:pkgId/premium

export const removePremium = async (userId, premiumPackageAmountId) => {
  try {
    let formData = new FormData()
    formData = {
      userId: userId,
      pkgId: premiumPackageAmountId,
    }

    const apiUrl = `/web/users/remove/premium`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const getSpotlightUsers = async (page, pageSize, userType) => {
  try {
    let formData = {
      page: page,
      pageSize: pageSize,
      registerFrom: userType,
    }

    const apiUrl = `/web/user/spotlight/get`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    return error.response.data
  }
}

export const removeSpotlightUser = async (userID) => {
  try {
    let formData = {
      userId: userID,
    }

    const apiUrl = `/web/user/spotlight/remove`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

/*For Chats */
export const getMessagesByUserID = async (userID, chatroomID, page, pageSize) => {
  try {
    let formData = {
      userId: userID,
      chatRoomId: chatroomID,
      page: page,
      pageSize: pageSize,
    }

    const apiUrl = `/web/communications/chat-member/message/get`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getChatMemberByUserID = async (
  userID,
  page,
  pageSize,
  registerFrom,
  search,
  userType
) => {
  try {
    let formData = {
      userId: userID,
      page: page,
      pageSize: pageSize,
      registerFrom: registerFrom,
      search: search,
      userType: userType,
    }

    const apiUrl = `/web/communications/chat-member/get`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllGifts = async (page, pageSize) => {
  try {
    const apiUrl = `/masters/gifts/web`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllGiftsCategory = async () => {
  try {
    const apiUrl = `/masters/gifts-category`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}


export const pinOrLikeChatMember = async (userID, roomID, chatID, action, currentActionValue) => {
  try {
    let formdata = {
      userId: userID,
      chatRoomId: roomID,
      chatMemberId: chatID,
    }
    if (action === 'pin') {
      formdata['isAdminPinned'] = currentActionValue
    } else if (action === 'like') {
      formdata['isAdminLiked'] = currentActionValue
    }

    const apiUrl = `/web/communications/chatMembers/update`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}



export const getAllMedia = async (page, pageSize, userID, userName) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
      userName: userName,
    }

    const apiUrl = `/web/profile/media`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteSelectedMedia = async (MediaId) => {
  try {
    let formData = {
      mediaIds: MediaId,
    }

    const apiUrl = `/web/users/media/delete/multiple`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}




// gifts plugin

export const getAllGiftCategory = async () => {
  try {
    const apiUrl = `/masters/gifts-category/`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const CreateGiftsCategory = async (name) => {
  try {
    let formData = new FormData()
    formData = {
      name: name,
    }

    const apiUrl = `/masters/gifts-category/`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateGiftsCategory = async (name, giftCategoryId) => {
  try {
    let formData = new FormData()
    formData = {
      name: name,
      giftCategoryId: giftCategoryId,
    }

    const apiUrl = `/masters/gifts-category/update`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteGiftsCategory = async (giftCategoryId) => {
  try {
    let data = {
      giftCategoryId: giftCategoryId,
    }

    const apiUrl = `/masters/gifts-category/delete`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllGift = async () => {
  try {
    const apiUrl = `/masters/gifts-category/with/gifts`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const CreateGift = async (name, categoryId, categoryName, credit, giftFile) => {
  try {
    let formData = new FormData()

    let fileName = categoryName + '.' + giftFile.name.split('.').pop()
    formData.append('gift', giftFile, fileName) // fileData[i].name .split(".")[0] + ".webp"
    formData.append(`credit`, credit)
    formData.append(`giftCategoryId`, categoryId)
    formData.append(`name`, name)

    const apiUrl = `/masters/gifts-category/gifts/create`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, true)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateGifts = async (name, categoryId, categoryName, credit, giftFile, giftId) => {
  try {
    let formData = new FormData()

    if (giftFile !== undefined && giftFile !== null && giftFile.length !== 0) {
      let fileName = categoryName + '.' + giftFile.name.split('.').pop()
      formData.append('gift', giftFile, fileName)
    }
    // fileData[i].name .split(".")[0] + ".webp"
    formData.append(`credit`, credit)
    formData.append(`giftCategoryId`, categoryId)
    formData.append(`name`, name)
    formData.append(`giftId`, giftId)

    const apiUrl = `/masters/gifts-category/gifts/update`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, true)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteGifts = async (giftCategoryId, giftId) => {
  try {
    let formData = {
      giftId: giftId,
    }

    const apiUrl = `/masters/gifts-category/gifts/delete`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

//master plugins

export const getConfigurationByName = async (name) => {
  try {
    const apiUrl = `/masters/configurations/types`

    let response = await request(apiUrl, API_TYPE.POST, { type: name }, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createConfiguration = async (data) => {
  try {
    const apiUrl = `/masters/configurations/create`
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const updateConfigurationByConfigID = async (ConfigID, values, gestureFile) => {
  try {
    let formData = new FormData()

    if (gestureFile === null) {
      formData = {
        values: JSON.stringify(values),
        configurationId: ConfigID,
      }
    } else {
      formData = {
        gesture: gestureFile,
        values: JSON.stringify(values),
        configurationId: ConfigID,
      }
    }

    const apiUrl = `/masters/configurations/update`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateNotificationConfigurationByConfigID = async (ConfigID, values, file) => {
  try {
    let formData = new FormData()
    if (file !== undefined && file !== null && file !== '') {
      formData.append('gesture', file)
    }
    formData.append('values', JSON.stringify(values))
    formData.append('configurationId', ConfigID)

    const apiUrl = `/masters/configurations/notification`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, true)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// site-pricing plugin

export const getCreditAndPremiumPackageAmountPlans = async () => {
  try {
    const apiUrl = `/masters/packages/credits/both`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCreditPackageAmountPlans = async () => {
  try {
    const apiUrl = `/masters/packages/credits?fromWeb=true`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const CreateCreditPackageAmountPlan = async (credit, totalAmount, amount) => {
  try {
    let formData = new FormData()
    formData = {
      credit: credit,
      totalAmount: totalAmount,
      amount: amount,
    }

    const apiUrl = `/masters/packages/credits/`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateCreditPackageAmountPlan = async (pkgId, credit, totalAmount, amount) => {
  try {
    let formData = new FormData()
    formData = {
      credit: credit,
      totalAmount: totalAmount,
      amount: amount,
      creditPackageAmountId: pkgId,
    }

    const apiUrl = `/masters/packages/credits/`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getPremiumPackageAmountPlans = async () => {
  try {
    const apiUrl = `/masters/packages/premium?fromWeb=true`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const CreatePremiumPackageAmountPlan = async (days, totalAmount, amount, pkgName) => {
  try {
    let formData = new FormData()
    formData = {
      days: days,
      totalAmount: totalAmount,
      amount: amount,
      premiumPackageName: pkgName,
    }

    const apiUrl = `/masters/packages/premium/`

    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updatePremiumPackageAmountPlan = async (pkgId, days, totalAmount, amount, pkgName) => {
  try {
    let formData = new FormData()
    formData = {
      days: days,
      totalAmount: totalAmount,
      amount: amount,
      premiumPackageName: pkgName,
      premiumPackageAmountId: pkgId,
    }

    const apiUrl = `/masters/packages/premium/`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}


//credit package details



//get users orders
export const getUserOrdersList = async (page, pageSize, filter, tabValue) => {
  let {
    search,
    startDate,
    endDate,
    searchType,
    searchDateType,
    orderType,
    transactionStatus,
    modeOfPayment,
    premiumPlans,
    creditPlans,
    gender,
    campaignNames,
    adsetNames,
    adNames,
    campaignStatus,
    orderStartDate,
    orderEndDate,
    userStartDate,
    userEndDate,
    organicUserOnly,
    onlyGclid,
  } = filter

  try {
    let replacements = {
      'Google Pay': 'google pay',
      Phonepay: 'phonepay',
      Razorpay: 'razorpay',
      'Apple Pay': 'apple pay',
      Cashfree: 'cashfree',
      'Cashfree UPI': 'cashfreeupi',
      'Cashfree YD': 'cashfreeyd',
      'Cashfree DP': 'cashfreedp',
      PayU: 'payu',
      'PayU Fun YD': 'payufunyd',
      Instantpaisa: 'instantpaisa',
    }

    modeOfPayment = modeOfPayment.map((method) => replacements[method] || method)

    let transactionStatusReplacements = {
      Pending: 'pending',
      Success: 'success',
      Failed: 'failed',
    }

    transactionStatus = transactionStatus.map(
      (method) => transactionStatusReplacements[method] || method
    )

    let data = {
      search,
      startDate,
      endDate,
      searchType,
      tabValue,
      orderType,
      searchDateType,
      transactionStatus,
      modeOfPayment,
      gender,
      PremiumPlanIds: premiumPlans,
      CreditPlanIds: creditPlans,
      campaignNames,
      adsetNames,
      adNames,
      campaignStatus,
      orderStartDate,
      orderEndDate,
      userStartDate,
      userEndDate,
      organicUserOnly,
      onlyGclid,
      page: page,
      pageSize: pageSize,
    }

    const apiUrl = `/web/purchase/order`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getMarketingFilterOptions = async (level, parentName, status) => {
  try {
    let data = {
      level: level,
      parentName: parentName,
      status: status,
    }

    const apiUrl = `/web/marketing/campaign-filter-options`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getGuestUserList = async (filter, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
    }

    if (filter.startDate && filter.endDate) {
      data['startDate'] = filter.startDate
      data['endDate'] = filter.endDate
    }

    if (filter.gender) {
      data['gender'] = filter.gender
    }

    if (filter.country) {
      data['country'] = filter.country
    }

    const apiUrl = `/web/user/guest/all`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// ref user commission

export const getUserRefUserCommissionList = async (page, pageSize) => {
  try {
    const apiUrl = `/web/referral-commissions/users?page=${page}&pageSize=${pageSize}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const addUserRefUserCommission = async (userId, percentage) => {
  try {
    const apiUrl = `/web/referral-commissions/users/create`

    let data = { userId, percentage }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const updateUserRefUserCommission = async (id, percentage, status) => {
  try {
    const apiUrl = `/web/referral-commissions/users/update`

    let data = { id, percentage, status }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteUserRefUserCommission = async (id) => {
  try {
    const apiUrl = `/web/referral-commissions/users/delete`

    let data = { id }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

//verification system

export const getVoiceVerificationList = async (page, pageSize, filters = {}) => {
  try {
    const apiUrl = `/web/users/voice-verification/get?page=${page}&pageSize=${pageSize}`
    let response = await request(apiUrl, API_TYPE.POST, filters, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const updateVoiceVerificationStatus = async (userID, verificationId, status, updateGenderTo, reason) => {
  try {
    let formData = {
      status: status,
      id: verificationId,
      userId: userID,
    }
    if (reason) formData.reason = reason;
    if (updateGenderTo) formData.updateGenderTo = updateGenderTo;

    const apiUrl = `/web/users/voice-verification/verify`
    let response = await request(apiUrl, API_TYPE.POST, formData, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getUserVerificationList = async (page, pageSize) => {
  try {
    const apiUrl = `/web/users/verification/list?page=${page}&pageSize=${pageSize}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateUserVerification = async (userID, verificationId, verifyStatus, reason) => {
  try {
    let formData = new FormData()
    if (verifyStatus === 'verified') {
      formData = {
        verifyStatus: verifyStatus,
        id: verificationId,
        userId: userID,
      }
    } else {
      formData = {
        verifyStatus: verifyStatus,
        reason: reason,
        id: verificationId,
        userId: userID,
      }
    }

    const apiUrl = `/web/users/verification`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// withdrawal requests

export const getUserWithDrawalRequestsList = async (page, pageSize, filter) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
    }

    console.log(filter)



    if (filter.search !== undefined) {
      data['search'] = filter.search
    }

    if (filter.userSearch !== undefined) {
      data['userSearch'] = filter.userSearch
    }

    if (filter.transactionStatus !== undefined) {
      data['transactionStatus'] = filter.transactionStatus
    }

    if (filter.requestId !== undefined) {
      data['requestId'] = filter.requestId
    }

    if (filter.withdrawId !== undefined) {
      data['withdrawId'] = filter.withdrawId
    }

    if (filter.startDate && filter.endDate) {
      data['startDate'] = filter.startDate
      data['endDate'] = filter.endDate
    }

    console.log(data)

    const apiUrl = `/web/withdraw/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateUserWithDrawalRequests = async (
  userId,
  withdrawalRequestId,
  transactionStatus,
  reason,
  credit,
  transactionId,
  adminUserId,
  amount,
  payoutGateway
) => {
  try {
    let formData = new FormData()
    if (transactionStatus === 'completed') {
      formData = {
        transactionStatus: transactionStatus,
        transactionId: transactionId,
        adminUserId: adminUserId,
        credit: credit,
        withdrawMoney: amount,
        withdrawId: withdrawalRequestId,
        userId: userId,
        payoutGateway: payoutGateway,
      }
    } else {
      formData = {
        transactionStatus: transactionStatus,
        reason: reason,
        credit: credit,
        adminUserId: adminUserId,
        withdrawMoney: amount,
        withdrawId: withdrawalRequestId,
        userId: userId,
        payoutGateway: payoutGateway,
      }
    }

    const apiUrl = `/web/withdraw/update`

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// anonymous users

export const getAllAnonymousUser = async (query) => {
  try {
    const apiUrl = `/web/anonymous/users/allUser?${query}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllAdminUser = async (query) => {
  try {
    const apiUrl = `/web/admin/users/get?${query}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllUserAnonymousMedia = async (page, pageSize, userID, userName) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
      userName: userName,
    }

    const apiUrl = `/web/anonymous/profile/media`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createNewAnonymousUser = async (values) => {
  try {
    const apiUrl = `/anonymous/users`

    let response = await request(apiUrl, API_TYPE.POST, values, true, false)
    if (response.success && response.data && response.data.userId) {
      localStorage.setItem('anonymousUserId', response.data.userId)
    }
    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const checkUserName = async (userName) => {
  try {
    const apiUrl = `/users/check/username`
    let data = {
      userName: userName,
    }

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}


export const getUserMediaImages = async (uid) => {
  try {
    const apiUrl = `/web/users/profile/media/all/${uid}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const UpdateUserInterestAndQuestions = async (UID, interests, questions) => {
  try {
    const apiUrl = `/users/update/${UID}`

    let formData = new FormData()
    formData.append('interests', JSON.stringify(interests))
    formData.append('questions', JSON.stringify(questions))

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, true)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// legal information plugins (policy)

export const getAllPolicies = async () => {
  try {
    const apiUrl = `/masters/policies/`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const UpdatePolicy = async (policyId, htmlText) => {
  try {
    const apiUrl = `/masters/policies/${policyId}`

    let formData = new FormData()
    formData = {
      html: htmlText,
    }

    let response = await request(apiUrl, API_TYPE.PUT, formData, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// Update folder structure config
export const UpdateFolderStructurePlugin = async (values, ConfigID) => {
  try {
    let data = {
      values: values,
      type: 'folder_structure',
      category: 'common',
      configId: ConfigID,
    }

    const apiUrl = `/masters/configurations/updateFolderStructureConfig`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

// interaction api start

export const getAllInteractionCount = async (userID) => {
  try {
    const apiUrl = `/web/users/interaction/allCount`

    let response = await request(apiUrl, API_TYPE.POST, { userId: userID }, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getLikesMeList = async (userID, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
    }

    const apiUrl = `/web/users/interaction/likes/me`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getVisitMeList = async (userID, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
    }

    const apiUrl = `/web/users/interaction/visit/me`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getMatchUserList = async (userID, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
    }

    const apiUrl = `/web/users/interaction/matched`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getMyLikesList = async (userID, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
    }

    const apiUrl = `/web/users/interaction/likes/my`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getMyVisitList = async (userID, page, pageSize) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      userId: userID,
    }

    const apiUrl = `/web/users/interaction/visit/my`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// interaction api end

// admin users api

export const getAllRoles = async () => {
  try {
    const apiUrl = `/masters/roles/`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response.data
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const sendNotificationToSelectedUser = async (userIds, message, title, imageUrl) => {
  try {
    let data = {
      userIds: userIds,
      message: message,
      title: title,
      imageUrl: imageUrl,
    }

    const apiUrl = `/web/users/send/notification`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// support Reason screen

export const getAllSupportReasons = async () => {
  try {
    const apiUrl = `/masters/support/reason`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createSupportReasons = async (reason) => {
  try {
    let formdata = new FormData()
    formdata = {
      reason: reason,
    }

    const apiUrl = `/masters/support/reason`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateSupportReasons = async (supportReasonId, reason) => {
  try {
    let formdata = new FormData()
    formdata = {
      reason: reason,
    }

    const apiUrl = `/masters/support/reason/${supportReasonId}`

    let response = await request(apiUrl, API_TYPE.PUT, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// support screen

export const getAllUsersSupports = async (page, pageSize, filters = {}) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
      ...filters,
    }

    const apiUrl = `/web/masters/support/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUsersSupportsChat = async (userId, supportId, page, pageSize) => {
  try {
    let formdata = new FormData()
    formdata = {
      userId: userId,
      supportId: supportId,
      page: page,
      pageSize: pageSize,
      isWeb: true,
    }

    const apiUrl = `/masters/support/get/messages`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const UpdateSupportTicketStatus = async (userId, supportId) => {
  try {
    let formdata = new FormData()
    formdata = {
      userId: userId,
      supportStatus: 'completed',
    }

    const apiUrl = `/masters/support/${supportId}/update`

    let response = await request(apiUrl, API_TYPE.PUT, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const deleteSupportTicket = async (supportId) => {
  try {
    const apiUrl = `/masters/support/${supportId}/delete`

    let response = await request(apiUrl, API_TYPE.DELETE, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllAnalytics = async (page, pageSize, filter) => {
  try {
    let formdata = new FormData()
    formdata = {
      page: page,
      pageSize: pageSize,
      type: filter.duration,
    }

    if (filter.startDate && filter.endDate) {
      formdata['startDate'] = filter.startDate
      formdata['endDate'] = filter.endDate
    }

    const apiUrl = `/web/analytics/all`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createAnalytics = async (marketingCost, otherCost) => {
  try {
    let formdata = new FormData()
    formdata = {
      marketingCost: marketingCost,
      otherCost: otherCost
    }

    const apiUrl = `/web/analytics/create`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const updateAnalytics = async (analytics) => {
  try {
    const apiUrl = `/web/analytics/update`

    let response = await request(apiUrl, API_TYPE.PUT, analytics, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const recalculateDailyAnalytics = async (analyticsId) => {
  try {
    let data = {
      analyticsId: analyticsId,
    }

    const apiUrl = `/web/analytics/recalculate`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const recalculateAllAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/recalculate/all`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const rebuildAnalytics = async () => {
  try {
    const apiUrl = `/createCronAnalytics`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getTodaysAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/currentAnalytics`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCurrentWeekAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/currentWeek`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCurrentMonthAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/currentMonth`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCurrentYearAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/currentYear`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserAnalytics = async (filter, dateFormat) => {
  let { duration, startDate, endDate, view } = filter
  try {
    let data = {
      duration: duration,
      view: view,
      format: dateFormat,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data['startDate'] = moment(startDate).format('YYYY-MM-DD')
      data['endDate'] = moment(endDate).format('YYYY-MM-DD')
    }

    const apiUrl = `/web/analytics/user`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCreditOrderAnalytics = async (
  filter,
  dateFormat,
  orderTypeFilter,
  paymentModeFilter
) => {
  let { duration, startDate, endDate, view, chartType } = filter
  try {
    orderTypeFilter = Object.keys(orderTypeFilter).filter((key) => orderTypeFilter[key] === true)

    paymentModeFilter = Object.keys(paymentModeFilter).filter(
      (key) => paymentModeFilter[key] === true
    )

    let replacedPaymentMethods = paymentModeFilter.map((method) => {
      if (method === 'googlePay') {
        return 'google pay'
      } else if (method === 'phonePay') {
        return 'phonepay'
      } else if (method === 'razorPay') {
        return 'razorpay'
      } else if (method === 'payU') {
        return 'payu'
      } else if (method === 'payuFunYd') {
        return 'payufunyd'
      } else if (method === 'cashFree') {
        return 'cashfree'
      } else if (method === 'cashFreeUpi' || method === 'cashFreeUPI') {
        return 'cashfreeupi'
      } else if (method === 'cashFreeYd' || method === 'cashFreeYD') {
        return 'cashfreeyd'
      } else if (method === 'cashFreeDp' || method === 'cashFreeDP') {
        return 'cashfreedp'
      } else if (method === 'instantPaisa' || method === 'Instantpaisa') {
        return 'instantpaisa'
      } else if (method === 'applePay') {
        return 'apple pay'
      } else {
        return method
      }
    })

    let data = {
      chartType: chartType,
      duration: duration,
      type: orderTypeFilter,
      view: view,
      format: dateFormat,
      paymentModes: replacedPaymentMethods,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data = {
        ...data,
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
      }
    }

    const apiUrl = `/web/analytics/creditOrder`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getPremiumOrderAnalytics = async (
  filter,
  dateFormat,
  orderTypeFilter,
  paymentModeFilter
) => {
  let { duration, startDate, endDate, view, chartType } = filter
  try {
    orderTypeFilter = Object.keys(orderTypeFilter).filter((key) => orderTypeFilter[key] === true)

    paymentModeFilter = Object.keys(paymentModeFilter).filter(
      (key) => paymentModeFilter[key] === true
    )

    let replacedPaymentMethods = paymentModeFilter.map((method) => {
      if (method === 'googlePay') {
        return 'google pay'
      } else if (method === 'phonePay') {
        return 'phonepay'
      } else if (method === 'razorPay') {
        return 'razorpay'
      } else if (method === 'payU') {
        return 'payu'
      } else if (method === 'payuFunYd') {
        return 'payufunyd'
      } else if (method === 'cashFree') {
        return 'cashfree'
      } else if (method === 'cashFreeUpi' || method === 'cashFreeUPI') {
        return 'cashfreeupi'
      } else if (method === 'cashFreeYd' || method === 'cashFreeYD') {
        return 'cashfreeyd'
      } else if (method === 'cashFreeDp' || method === 'cashFreeDP') {
        return 'cashfreedp'
      } else if (method === 'instantPaisa' || method === 'Instantpaisa') {
        return 'instantpaisa'
      } else if (method === 'applePay') {
        return 'apple pay'
      } else {
        return method
      }
    })

    let data = {
      chartType: chartType,
      duration: duration,
      type: orderTypeFilter,
      view: view,
      format: dateFormat,
      paymentModes: replacedPaymentMethods,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data = {
        ...data,
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
      }
    }

    const apiUrl = `/web/analytics/premiumOrder`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getTotalOrderAnalytics = async (
  filter,
  dateFormat,
  orderTypeFilter,
  paymentModeFilter
) => {
  let { duration, startDate, endDate, view } = filter
  try {
    orderTypeFilter = Object.keys(orderTypeFilter).filter((key) => orderTypeFilter[key] === true)

    paymentModeFilter = Object.keys(paymentModeFilter).filter(
      (key) => paymentModeFilter[key] === true
    )

    let replacedPaymentMethods = paymentModeFilter.map((method) => {
      if (method === 'googlePay') {
        return 'google pay'
      } else if (method === 'phonePay') {
        return 'phonepay'
      } else if (method === 'razorPay') {
        return 'razorpay'
      } else if (method === 'payU') {
        return 'payu'
      } else if (method === 'payuFunYd') {
        return 'payufunyd'
      } else if (method === 'cashFree') {
        return 'cashfree'
      } else if (method === 'cashFreeUpi' || method === 'cashFreeUPI') {
        return 'cashfreeupi'
      } else if (method === 'cashFreeYd' || method === 'cashFreeYD') {
        return 'cashfreeyd'
      } else if (method === 'cashFreeDp' || method === 'cashFreeDP') {
        return 'cashfreedp'
      } else if (method === 'instantPaisa' || method === 'Instantpaisa') {
        return 'instantpaisa'
      } else if (method === 'applePay') {
        return 'apple pay'
      } else {
        return method
      }
    })

    let data = {
      duration: duration,
      type: orderTypeFilter,
      view: view,
      format: dateFormat,
      paymentModes: replacedPaymentMethods,
    }

    if (duration !== 'today' && duration !== 'yesterday') {
      data = {
        ...data,
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
      }
    }

    const apiUrl = `/web/analytics/totalOrder`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getGenderWiseAnalytics = async (type) => {
  try {
    let apiUrl = `/masters/analytics/genderWise?type=${type}`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getPackagesAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/packageAnalytics`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCountryWiseUserAnalytics = async () => {
  try {
    let apiUrl = `/masters/analytics/countryWiseUser`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getStateWiseUserAnalytics = async (countryName, stateFilter) => {
  try {
    let apiUrl = `/masters/analytics/stateWiseUser?country=${countryName}&stateFilter=${stateFilter}`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getCityWiseUserAnalytics = async (countryName, stateName, cityFilter) => {
  try {
    let apiUrl = `/masters/analytics/cityWiseUser?state=${stateName}&country=${countryName}&cityFilter=${cityFilter}`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getDashboardAnalytics = async () => {
  try {
    const apiUrl = `/web/analytics/analytics-dashboard`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}


export const getAllDailyRewards = async () => {
  try {
    const apiUrl = `/daily-reward/get-all`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const createDailyReward = async (data) => {
  try {
    const apiUrl = `/daily-reward/create`
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const updateDailyReward = async (data) => {
  try {
    const apiUrl = `/daily-reward/update`
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteDailyReward = async (dailyRewardId) => {
  try {
    const apiUrl = `/daily-reward/delete`
    let response = await request(apiUrl, API_TYPE.POST, { dailyRewardId }, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const scheduleCron = async (type, time, title, message, imageUrl) => {
  try {
    let data = {
      type: type,
      time: time,
      title: title,
      message: message,
      imageUrl: imageUrl,
    }

    const apiUrl = `/notifications/scheduleCron`
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getSideBarCount = async () => {
  try {
    const apiUrl = `/web/users/sidebarCount`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getAllBlockedUserList = async (page, pageSize, filter = null) => {
  try {
    let data = {
      page: page,
      pageSize: pageSize,
    }

    if (filter) {
      if (filter.userId) data.userId = filter.userId;
      if (filter.blockUserId) data.blockUserId = filter.blockUserId;
      if (filter.startDate) data.startDate = filter.startDate;
      if (filter.endDate) data.endDate = filter.endDate;
      if (filter.reasons && filter.reasons.length > 0) data.reasons = filter.reasons;
    }

    const apiUrl = `/web/users/block/get`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserAllStatistics = async (userType) => {
  try {
    let data = { type: userType }

    const apiUrl = `/web/anonymous/users/statistics`

    let response = await request(apiUrl, API_TYPE.POST, data, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createChatMemberAndSendMessage = async (senderId, receiverId, message) => {
  try {
    let formdata = {
      senderId: senderId,
      receiverId: receiverId,
      message: message,
    }

    const apiUrl = `/web/communications/create-chat-room`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getInvoiceData = async (filter, type) => {
  try {
    let formdata = { ...filter }

    if (filter?.startDate) {
      formdata['startDate'] = filter?.startDate
    }

    if (filter?.endDate) {
      formdata['endDate'] = filter?.endDate
    }

    if (filter?.paymentVia) {
      formdata['paymentVia'] = filter?.paymentVia
    }

    if (filter?.startTime) {
      formdata['startTime'] = filter?.startTime
    }

    if (filter?.endTime) {
      formdata['endTime'] = filter?.endTime
    }

    if (type) {
      formdata['type'] = type
    }

    const apiUrl = `/web/invoice/create`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getUserReferralWithPagination = async (userID) => {
  try {
    const apiUrl = `/web/users/referral/${userID}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteAccountPermanent = async (userIDs) => {
  try {
    let formdata = {
      userIds: userIDs,
    }

    const apiUrl = `/web/users/delete/permanent`

    let response = await request(apiUrl, API_TYPE.POST, formdata, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getUserVideoCalls = async (userId, page, pageSize, filter) => {
  try {
    let apiUrl = `/web/communications/videoCalls/users/${userId}?page=${page}&pageSize=${pageSize}`
    if (filter) {
      if (filter.startDate) apiUrl += `&startDate=${filter.startDate}`
      if (filter.endDate) apiUrl += `&endDate=${filter.endDate}`
      if (filter.callStatus) apiUrl += `&callStatus=${filter.callStatus}`
    }

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteUserVideoCall = async (videoCallId) => {
  try {
    const apiUrl = `/web/communications/videoCalls/delete?videoCallId=${videoCallId}`

    let response = await request(apiUrl, API_TYPE.DELETE, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getUserRandomCalls = async (userId, page, pageSize, filter) => {
  try {
    const { callStatus, startDate, endDate, isFreeCall, callType } = filter || {}
    let apiUrl = `/web/communications/randomCalls/users/${userId}?page=${page}&pageSize=${pageSize}`
    if (callStatus) apiUrl += `&callStatus=${callStatus}`
    if (startDate) apiUrl += `&startDate=${startDate}`
    if (endDate) apiUrl += `&endDate=${endDate}`
    if (isFreeCall) apiUrl += `&isFreeCall=${isFreeCall}`
    if (callType) apiUrl += `&callType=${callType}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getAllVideoCalls = async (page, pageSize, filter) => {
  try {
    let apiUrl = `/web/communications/videoCalls/admin/all?page=${page}&pageSize=${pageSize}`

    if (filter.startDate && filter.endDate) {
      apiUrl += `&startDate=${filter.startDate}&endDate=${filter.endDate}`
    }

    if (filter.search) {
      apiUrl += `&search=${filter.search}`
    }

    if (filter.callStatus) {
      apiUrl += `&callStatus=${filter.callStatus}`
    }

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getUserAudioCalls = async (userId, page, pageSize, filter) => {
  try {
    let apiUrl = `/web/communications/audioCalls/users/${userId}?page=${page}&pageSize=${pageSize}`
    if (filter) {
      if (filter.startDate) apiUrl += `&startDate=${filter.startDate}`
      if (filter.endDate) apiUrl += `&endDate=${filter.endDate}`
      if (filter.callStatus) apiUrl += `&callStatus=${filter.callStatus}`
    }

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteUserAudioCall = async (audioCallId) => {
  try {
    const apiUrl = `/web/communications/audioCalls/delete?audioCallId=${audioCallId}`

    let response = await request(apiUrl, API_TYPE.DELETE, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getAllAudioCalls = async (page, pageSize, filter) => {
  try {
    let apiUrl = `/web/communications/audioCalls/admin/all?page=${page}&pageSize=${pageSize}`

    if (filter.startDate && filter.endDate) {
      apiUrl += `&startDate=${filter.startDate}&endDate=${filter.endDate}`
    }

    if (filter.search) {
      apiUrl += `&search=${filter.search}`
    }

    if (filter.callStatus) {
      apiUrl += `&callStatus=${filter.callStatus}`
    }

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const deleteUserRandomCall = async (randomCallId) => {
  try {
    const apiUrl = `/web/communications/randomCalls/delete?randomCallId=${randomCallId}`

    let response = await request(apiUrl, API_TYPE.DELETE, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getAllRandomCalls = async (page, pageSize, filter) => {
  try {
    let apiUrl = `/web/communications/randomCalls/admin/all?page=${page}&pageSize=${pageSize}`

    if (filter.startDate && filter.endDate) {
      apiUrl += `&startDate=${filter.startDate}&endDate=${filter.endDate}`
    }

    if (filter.search) {
      apiUrl += `&search=${filter.search}`
    }

    if (filter.callStatus) {
      apiUrl += `&callStatus=${filter.callStatus}`
    }

    if (filter.isFreeCall !== undefined && filter.isFreeCall !== '') {
      apiUrl += `&isFreeCall=${filter.isFreeCall}`
    }

    if (filter.callType) {
      apiUrl += `&callType=${filter.callType}`
    }

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const rebuildAllAnalytics = async () => {
  try {
    const apiUrl = `/createCronAnalytics`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const createManualOrder = async (orderData) => {
  try {
    const apiUrl = `/web/payment/create/manual`

    let response = await request(apiUrl, API_TYPE.POST, orderData, true, false)


    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

export const getOrderByOrderId = async (orderId) => {
  try {
    const apiUrl = `/web/payment/order/lookup?orderId=${encodeURIComponent(orderId)}`

    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)

    return response
  } catch (error) {
    console.log(error.message)

    return error.message
  }
}

// =============== Notification Templates ===============

export const getAllNotificationTemplates = async () => {
  try {
    const apiUrl = `/masters/notification-templates`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response.data
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const updateNotificationTemplate = async (caseKey, data) => {
  try {
    const apiUrl = `/masters/notification-templates/${caseKey}`
    let response = await request(apiUrl, API_TYPE.PUT, data, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const toggleNotificationTemplate = async (caseKey) => {
  try {
    const apiUrl = `/masters/notification-templates/${caseKey}/toggle`
    let response = await request(apiUrl, API_TYPE.PATCH, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}

export const getInvoiceCompanies = async () => {
  try {
    const apiUrl = `/web/invoice/companies`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}
export const getAllAvatars = async () => {
  try {
    const apiUrl = `/masters/avatars`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in Get All Avatars', error.message)
    return error.message
  }
}

export const createAvatar = async (gender, file) => {
  try {
    const formData = new FormData()
    formData.append('gender', gender)
    if (file !== undefined && file !== null && file !== '') {
      formData.append('avatar', file)
    }

    const apiUrl = `/masters/avatars`

    const response = await request(apiUrl, API_TYPE.POST, formData, true, true)
    return response
  } catch (error) {
    CustomLogger.error('Error in Create Avatar', error.message)
    return error.message
  }
}

export const deleteAvatar = async (avatarId) => {
  try {
    const apiUrl = `/masters/avatars/${avatarId}`
    let response = await request(apiUrl, API_TYPE.DELETE, {}, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in Delete Avatar', error.message)
    return error.message
  }
}

export const getUserSettingByUserId = async (userId) => {
  try {
    const apiUrl = `/web/users/setting/get`
    let response = await request(apiUrl, API_TYPE.POST, { userId }, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in Get User Setting', error.message)
    return error.message
  }
}

export const updateUserSettingByUserId = async (userId, data) => {
  try {
    const apiUrl = `/web/users/setting/update`
    let response = await request(apiUrl, API_TYPE.POST, { userId, data }, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in Update User Setting', error.message)
    return error.message
  }
}
export const uploadMedia = async (file) => {
  try {
    const formData = new FormData()
    if (file !== undefined && file !== null && file !== '') {
      formData.append('gesture', file)
    }

    const apiUrl = `/masters/upload`
    const response = await request(apiUrl, API_TYPE.POST, formData, true, true)
    return response
  } catch (error) {
    console.log('error', error)
    return { success: false }
  }
}
export const getLeaderboardData = async (data) => {
  try {
    const apiUrl = `/web/leaderboard/get`
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in getLeaderboardData', error.message)
    return error.message
  }
}

export const getLeaderboardRewardLogs = async (data) => {
  try {
    const apiUrl = `/web/leaderboard/rewards/logs`
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in getLeaderboardRewardLogs', error.message)
    return error.message
  }
}


export const getSpinWheelRewards = async () => {
  try {
    const apiUrl = '/spin-wheel-reward/get-all'
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response.data
  } catch (error) {
    CustomLogger.error('Error in getSpinWheelRewards', error.message)
    return error.message
  }
}

export const updateSpinWheelReward = async (data) => {
  try {
    const apiUrl = '/spin-wheel-reward/update'
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in updateSpinWheelReward', error.message)
    return error.message
  }
}


export const getCampaignAnalyticsDashboard = async (data) => {
  try {
    const apiUrl = '/web/analytics/campaign-dashboard'
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in getCampaignAnalyticsDashboard', error.message)
    return error.message
  }
}

export const updateMarketingSpend = async (data) => {
  try {
    const apiUrl = '/web/analytics/update-spend'
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in updateMarketingSpend', error.message)
    return error.message
  }
}

export const toggleMarketingAdStatus = async (data) => {
  try {
    const apiUrl = '/web/analytics/toggle-status'
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in toggleMarketingAdStatus', error.message)
    return error.message
  }
}

export const toggleBulkMarketingAdStatus = async (data) => {
  try {
    const apiUrl = '/web/analytics/bulk-toggle-status'
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in toggleBulkMarketingAdStatus', error.message)
    return error.message
  }
}

export const getMarketingAdSpendHistory = async (data) => {
  try {
    const apiUrl = '/web/analytics/spend-history'
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in getMarketingAdSpendHistory', error.message)
    return error.message
  }
}

export const updateBulkMarketingSpend = async (data) => {
  try {
    const apiUrl = '/web/analytics/bulk-update-spend'
    let response = await request(apiUrl, API_TYPE.POST, data, true, false)
    return response
  } catch (error) {
    CustomLogger.error('Error in updateBulkMarketingSpend', error.message)
    return error.message
  }
}

export const getUserDeviceInfo = async (userId) => {
  try {
    const apiUrl = `/web/users/device-info/${userId}`
    let response = await request(apiUrl, API_TYPE.GET, {}, true, false)
    return response
  } catch (error) {
    console.log(error.message)
    return error.message
  }
}
export const getBlockedUsersWithPagination = async (page, pageSize, userId, blockUserId) => { try { const apiUrl = '/web/users/block/get'; let data = { page, pageSize }; if (userId) data.userId = userId; if (blockUserId) data.blockUserId = blockUserId; return await request(apiUrl, API_TYPE.POST, data, true, false); } catch (error) { return error.message; } }; export const getBlockReasonsStats = async (userId, type) => {
  try {
    const apiUrl = '/web/users/block/stats';
    return await request(apiUrl, API_TYPE.POST, { userId, type }, true, false);
  } catch (error) {
    return error.message;
  }
}; export const unblockUser = async (blockId) => { try { const apiUrl = '/web/users/block/unblock'; return await request(apiUrl, API_TYPE.POST, { blockId }, true, false); } catch (error) { return error.message; } };
